export const REACT_QUERY_PERSIST_KEY = 'ads-frontend-react-query-cache';
export const REACT_QUERY_PERSIST_BUSTER = 'rq-cache-v2';

export const queryKeys = {
  locationTodosAndTasks: 'locationTodosTasks',
  totalSpacesCount: 'totalSpacesCount',
  spacesFilters: 'spacesFilters',
  spacesFiltersAddSpaces: 'spacesFiltersAddSpaces',
  spacesFiltersAddSpacesView: 'spacesFiltersAddSpacesView',
  spacesFiltersAddSpacesOrder: 'spacesFiltersAddSpacesOrder',
  user: 'user',
  userAvatar: 'user avatar',
  location: 'location',
  allLocations: 'all location',
  users: 'users task',
  teamMembers: 'team members',
  advertisingSpaces: 'advertising spaces',
  companies: 'companies',
  companyDetails: 'company details',
  companyLocations: 'company locations',
  companyLocationsWithSpaces: 'companyLocationsWithSpaces',
  companyClients: 'company clients',
  placementAreas: 'placement areas',
  supportIds: 'support ids',
  illuminationOptions: 'illuminationOptions',
  installmentOptions: 'installmentOptions',
  materialTypeOptions: 'materialTypeOptions',
  baseOptions: 'baseOptions',
  heightOptions: 'heightOptions',
  sizeOptions: 'sizeOptions',
  piecesOptions: 'piecesOptions',
  facesOptions: 'facesOptions',
  orders: 'orders',
  mediaPlans: 'media plans',
  mediaPlanFilters: 'media plan filters',
  orderFilters: ' order filters',
  signupRequests: 'signup requests',
  currentUser: 'current user',
  currentUserAvatar: 'current user avatar',
  spacesAvailability: 'spaces availability',
  packagesAvailability: 'packages availability',
  services: 'services',
  dataGridViews: 'data grid views',
  rebatePolicies: 'rebate policies',
  tableHeaders: 'table headers',
  permissions: 'permissions',
  levels: 'levels',
  notifications: 'notifications',
  notificationsCalendar: 'notifications calendar',
  notificationsCount: 'notifications count',
  notificationsCountBreakdown: 'notifications count breakdown',
  userPreferences: 'user preferences',
  userTour: 'user-tour',
  locationCities: 'location cities',
  comments: 'comments',
  organization: 'organization',
  activeCampaigns: 'active campaigns',
  activeCampaignsWtihCounts: 'active campaigns counts',
  getActiveCampaignsWithCountsById: 'active campaigns counts by id',
  locations: 'locations',
  locationFloorMaps: 'location floor maps',
  filters: 'filters',
  tasks: 'tasks',
  serviceOrders: 'service orders',
  journeyProgress: 'journey-progress',
  kiosks: 'kiosks',
  keyVisuals: 'key visuals',
  leasingClients: 'leasing clients',
  advertisingPackages: 'advertising packages',
  advertisingPackagesForSpace: 'advertising packages for space',
  serviceTaskFilters: 'service task filters',
  serviceSuppliers: 'service suppliers',
  supportNamePictures: 'support name pictures',
  userList: 'list of users',
  usersByLocation: 'users by location',
  usersByLocations: 'users by locations',
  todos: 'todos',
  advertiserTodos: 'advertiser todos',
  locationTargets: 'location targets',
  locationContactCandidates: 'location contact candidates',
  mediaPlanFilterValues: 'media plan filter values',
  commercialConditions: 'commercial conditions',
  externalOrgCommercialTerms: 'external org commercial terms',
  serviceTaskDocuments: 'service task documents',
  serviceTaskTodos: 'service task todos',
  thumbnails: 'thumbnails',
  documentBlob: 'document blob',
  bookingServiceTasksStatus: 'booking service tasks status',
  floorPlanImage: 'floor-plan-image',
  orderHistory: 'order history',
  weatherForecast: 'weather forecast',
  servicesDashboard: 'services dashboard',
  invoices: 'invoices',
  invoiceTemplates: 'invoice templates',
  search: 'search',
  assistant: 'assistant',
  shipping: 'shipping',
  shippingNomenclator: 'shipping nomenclator',
  artworkDrive: 'artwork drive',
};

export const PERSISTED_QUERY_KEYS = new Set<string>([
  queryKeys.currentUser,
  queryKeys.userPreferences,
  queryKeys.userTour,
  queryKeys.allLocations,
  queryKeys.locationCities,
  queryKeys.placementAreas,
  queryKeys.supportIds,
  queryKeys.illuminationOptions,
  queryKeys.installmentOptions,
  queryKeys.materialTypeOptions,
  queryKeys.baseOptions,
  queryKeys.heightOptions,
  queryKeys.sizeOptions,
  queryKeys.piecesOptions,
  queryKeys.facesOptions,
  queryKeys.permissions,
  queryKeys.levels,
  queryKeys.weatherForecast,
]);
